import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../core/i18n/translation.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  readonly i18n = inject(TranslationService);

  currentYear = new Date().getFullYear();

  socialLinks = [
    { icon: 'pi-linkedin', href: '#', label: 'LinkedIn' },
    { icon: 'pi-twitter', href: '#', label: 'Twitter' },
    { icon: 'pi-youtube', href: '#', label: 'YouTube' },
    { icon: 'pi-github', href: '#', label: 'GitHub' },
  ];
}
